import { PROFILE, LINKS } from "@/content";
import { useLanguage } from "@/lang";
import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export const Footer = () => {
  const { copy } = useLanguage();

  return (
  <footer data-testid="footer" className="border-t border-white/10">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <p className="font-display italic text-2xl tracking-tight">{PROFILE.name}</p>
        <p className="text-xs uppercase tracking-[0.25em] text-zinc-600 mt-2">
          © {new Date().getFullYear()} — {copy.footer.role}, {copy.footer.location}
        </p>
      </div>

      <div className="flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-zinc-500">
        <a data-testid="footer-instagram" href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300">Instagram</a>
        <a data-testid="footer-imdb" href={LINKS.imdb} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300">IMDb</a>
        <Link data-testid="footer-impressum" to="/impressum" className="hover:text-white transition-colors duration-300">{copy.footer.impressum}</Link>
        <button
          data-testid="footer-back-to-top"
          onClick={() => {
            const lenis = window.__lenis;
            if (lenis) lenis.scrollTo(0);
            else window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          aria-label="Nach oben"
          className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-white/60 hover:-translate-y-1 transition-[border-color,transform] duration-300"
        >
          <ArrowUp size={15} />
        </button>
      </div>
    </div>
  </footer>
  );
};
